import ReactGA from 'react-ga4';

type TrackClickParams = {
  category: string;
  action?: string;
  label: string;
  value?: number;
};

export const trackClick = ({ category, action = 'Click', label, value }: TrackClickParams) => {
  ReactGA.event({
    category,
    action,
    label,
    ...(typeof value === 'number' ? { value } : {}),
  });
};

export const trackLinkClick = (category: string, label: string, href?: string) => {
  trackClick({
    category,
    action: 'Link Click',
    label: href ? `${label} | ${href}` : label,
  });
};

export const trackButtonClick = (category: string, label: string, action?: string) => {
  trackClick({
    category,
    action: action || 'Button Click',
    label,
  });
};